/**
 * Detail cast snippet
 * 
 * @author Mautilus s.r.o.
 * @class Snippet_DetailCast
 * @extends Snippet
 */

Snippet_DetailCast = (function (Snippet) {

    var Snippet_DetailCast = function () {
        this.construct.apply(this, arguments);
    };

    $.extend(true, Snippet_DetailCast.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
        init: function (parent, config) {
            this.$lastFocused = null;
        },

		/**
		 * @inheritdoc Snippet#create
		 */
        create: function () {
            return $("#snippet-detail-cast", this.parent.$el);
        },

		/**
		 * @inheritdoc Snippet#render
		 */
        render: function () {
            this.clear();
            this.index = 0;
            this.minIndex = 0;
            this.visibleCount = 3;
            // make HTML template
            var html = this.getTemplate(this.config.cast);
            if (!this.$el.length || !this.$el.html().length) {
                this.$el = this.create();
            }
            // append HTML to DOM
            this.$el.html(html);
            this.$castWrapper = $("#cast", this.$el);
            this.$leftArrow = $('.nav-left', this.$el);
            this.$rightArrow = $('.nav-right', this.$el);

            this.$leftArrow.addClass('hide');
            if (this.castCount <= this.visibleCount) this.$rightArrow.addClass('hide');
        },

		/**
		 * To get HTML template
		 */
        getTemplate: function (cast) {
            var items = '<ul id="cast">';
            var item = '';
            this.castCount = 0;
            for (var i in cast) {
                var category = cast[i];
                for (var j in category) {
                    var person = category[j];
                    this.castCount++;
                    item = 
                        '<li class="person ' + (this.castCount > 3 ?'': 'focusable') + ' '+this.castCount+'">' +
                        '   <div>' +
                        '       <div class="name">' + person.name + '</div>' +
                        '       <div class="role">' + person.role + '</div>' +
                        '   </div>' +
                        '</li>';
                    items += item;
                }
            }
            items += 
                '</ul>' +
                '<div class="nav-left clickable" data-id="left"></div>' +
                '<div class="nav-right clickable" data-id="right"></div>';
            return items;
        },

		/**
		 * @inheritdoc Snippet#onClick
		 */
        onClick: function ($el, event) {
            // if (this.trigger('click', $el, event) === false) {
            //     return false;
            // }
            return this.onEnter.apply(this, arguments);
        },
		/**
		 * @inheritdoc Snippet#onEnter
		 */
        onEnter: function ($el, event) {
            var id = $el.attr('data-id');
			if (id === 'right') {
				this.navigateSlider(3 - (this.index - this.minIndex));
			} else if (id === 'left') {
				this.navigateSlider(-1 - (this.index - this.minIndex));
            }
            return false;
        },

		/**
		 * @inheritdoc Snippet#onScroll
		 */
		onScroll: function($el, delta, e, stop) {
			if (delta > 0) {
				this.navigateSlider(-1);
			} else {
				this.navigateSlider(1);
			}
		},

		/**
		 * @inheritdoc Snippet#navigate
		 */
        navigate: function (direction) {
            if (direction == "up") { this.trigger("focus:out", this, direction); }
            else if (direction == "down") { this.trigger("focus:out", this, direction); }
            else if (direction == "left") { 
                this.navigateSlider(-1);
            }
            else if (direction == "right") { 
                this.navigateSlider(1);
            }
            return false;
        },

        moveSlider: function (index, itemWidth) {
            var visibleCount = 3,
                itemWidth = 322 + 6, // item width + margin
                initialLeft = 60;
            // wrapper position based on minIndex
            if(index + visibleCount ===  this.castCount) 
                this.$castWrapper.css('left', 4*initialLeft - index * itemWidth + 'px');            
            else
                this.$castWrapper.css('left', initialLeft - index * itemWidth + 'px');            
        },

        navigateSlider: function(amount) {
            var visibleCount = 3,
                sliceOffset = this.minIndex;
                maxIndex = this.minIndex + visibleCount - 1;

            // set new index    
            this.index += amount;

            // lower boundary
            if(this.index < 0) this.index = 0;
            
            // upper boundary
            if(this.index > this.castCount - 1) this.index = this.castCount - 1;

            // move to right
            if(this.index > maxIndex) {
                // if (this.minIndex > 0) {
                //     this.$castWrapper.children().eq(this.minIndex).removeClass('focusable');
                // }
                // console.log(maxIndex < this.castCount);
                // if(maxIndex < this.castCount) {
                //     this.$castWrapper.children().eq(maxIndex).addClass('focusable');
                //     console.log(this.$castWrapper.children().eq(maxIndex+1).addClass('focusable').html());
                // }
                this.minIndex++;
                this.moveSlider(this.minIndex);
            // move to left
            } else if(this.index < this.minIndex) {
                // if (this.minIndex > 0)
                //     this.$castWrapper.children().eq(this.minIndex).addClass('focusable');
                // if(maxIndex <= this.castCount)
                //     this.$castWrapper.children().eq(maxIndex).removeClass('focusable');
                this.minIndex--;
                this.moveSlider(this.minIndex);
            }
            // always set new focus
            Focus.to(this.$castWrapper.children().eq(this.index));
            if (this.index === 0) {
                this.$leftArrow.addClass('hide');
            } else if (this.index === this.castCount - 1) {
                this.$rightArrow.addClass('hide');
            } else {
                this.$leftArrow.removeClass('hide');
                this.$rightArrow.removeClass('hide');
            }
            
            // handling of focusable class - needed for kinetic/mouse input
            sliceOffset = this.minIndex - sliceOffset;
            var $selectables = $('.person', this.$el).slice(this.minIndex, maxIndex + sliceOffset + 1);
            $selectables.addClass('focusable');
            $('.person', this.$el).not($selectables).removeClass('focusable');
        },

		/**
		 * @inheritdoc Snippet#focus
		 */
        focus: function ($el) {
            if(this.$lastFocused) {
                return Focus.to(this.$lastFocused);
            }
            if (!$el) {
                $el = this.getFocusable(0);
            }
            return Focus.to($el);
        },

		/**
		 * @inheritdoc Snippet#focus
		 */
        onFocus: function ($el) {
            this.index = $el.index();
            this.$lastFocused = $el;
        },

        clear: function () {
            this.$el.empty();
            this.$lastFocused = null;
        },

		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Snippet
		 * 
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
        onFocusOut: function (snippet, direction) {
        }

    });

    return Snippet_DetailCast;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/detail_cast.js
// module id = 64
// module chunks = 0